import React from "react";

export interface TeaxtAreaProps
  extends React.DetailedHTMLProps<
    React.TextareaHTMLAttributes<HTMLTextAreaElement>,
    HTMLTextAreaElement
  > {}

const TextArea: React.FC<TeaxtAreaProps> = ({ ...props }) => (
  <textarea className="fl-p-4 fl-rounded-md" {...props} />
);

export default TextArea;
